import Router from 'next/router'
import StateStorage from 'lib/state-storage'
import { getFilterParams } from 'lib/utils/category'
import {
  clearArrayDuplicate,
  getElementStyleProperty,
} from 'lib/utils/common/commonUtils'
import { ITEMS_LIMIT } from './const'

const getSearchBarMargin = () =>
  getElementStyleProperty({
    className: 'search-bar-active',
    key: 'margin',
    pos: 0,
  })

const getSearchResultParams = (filter, page, query, sortData) => {
  const sortAndFilterOptions = {
    'filter[order_by]': sortData,
    ...getFilterParams(filter),
  }

  return JSON.stringify({
    params: {
      query,
      'filter[skip]': page * ITEMS_LIMIT,
      'filter[limit]': ITEMS_LIMIT,
      ...sortAndFilterOptions,
    },
  })
}

const goToSearchPage = (searchWord, callback) => {
  const shop = StateStorage.getShop()
  const language = StateStorage.getLanguage()
  const encodedSearchWord = encodeURIComponent(searchWord)

  Router.push(
    `/search?term=${encodedSearchWord}`,
    `/${shop}/${language}/search/${encodedSearchWord}`,
  ).then(() => {
    callback()
  })
}

const SEARCH_HISTORY_DETAILS = 'recentSearchListV2'

const clearRecentSearch = () => {
  StateStorage.removeCookie('recentSearchList')
  StateStorage.removeCookie(SEARCH_HISTORY_DETAILS)
}

const setRecentSearchItems = (recentSearchList) => {
  const searchItemList = recentSearchList.toString()
  StateStorage.setCookie('recentSearchList', searchItemList)
  StateStorage.setCookie(
    SEARCH_HISTORY_DETAILS,
    JSON.stringify(recentSearchList),
  )
}

const getRecentSearchItems = () => {
  const serializedState = StateStorage.getCookie('recentSearchList')

  if (!serializedState) {
    return undefined
  }

  // Older open pages still write/clear the original cookie. Only use the
  // lossless list while it agrees with that cookie; never resurrect old history.
  try {
    const details = JSON.parse(
      StateStorage.getCookie(SEARCH_HISTORY_DETAILS) || 'null',
    )
    if (
      Array.isArray(details) &&
      details.every((term) => typeof term === 'string') &&
      details.toString() === serializedState
    ) {
      return details.slice(0, 10)
    }
  } catch (error) {
    // An absent or malformed optional cookie must not break search.
  }

  const recentSearchList = serializedState.split(',')
  if (recentSearchList.length > 10) {
    recentSearchList.splice(10)
    setRecentSearchItems(recentSearchList)
  }

  return recentSearchList
}

const storeRecentSearchTerm = (term) => {
  let searchItem = getRecentSearchItems() || []
  searchItem.unshift(term)

  if (searchItem.includes(term)) {
    searchItem = clearArrayDuplicate(searchItem)
  }

  if (searchItem.length > 10) {
    searchItem.pop()
  }

  setRecentSearchItems(searchItem)
}

const storeTheSearchWord = (searchWord, setSearchWord) => {
  storeRecentSearchTerm(searchWord)
  sessionStorage.setItem('recent-search-word', searchWord)
  setSearchWord(searchWord)
}

const generateKeywordList = (length) =>
  Array.from({ length }, (_, i) => `Keyword ${i + 1}`)

const getKeywordList = (isRecentSearchListValid, recentSearchList) => {
  const generatedKeywords = generateKeywordList(5)
  const keywordList = isRecentSearchListValid
    ? recentSearchList
    : generatedKeywords

  return keywordList
}

const checkHasFilterQuickSize = (filter, isPhone, quickSizes) => {
  const isFilterValid = Object.values(filter).some(
    ({ values }) => values.length > 0,
  )

  return isPhone ? isFilterValid && quickSizes : isFilterValid
}

export {
  checkHasFilterQuickSize,
  clearRecentSearch,
  getKeywordList,
  getRecentSearchItems,
  getSearchBarMargin,
  getSearchResultParams,
  goToSearchPage,
  storeTheSearchWord,
}
